__webpack_require__.p = "https://customization.dev.hallmark.com/";